import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'image-illustration',
  templateUrl: './image-illustration.component.html',
  styleUrls: ['./image-illustration.component.css']
})
export class ImageIllustrationComponent implements AfterViewInit{

  @ViewChild('canvas', { static: true }) canvas: ElementRef<HTMLCanvasElement>;
  @Input() imagePath: string;
  @Input() text: string = 'Sample Text';
  @Input() rectColor: string = 'red';
  @Input() textColor: string = 'blue';
  @Input() rectWidth: number = 200;
  @Input() rectHeight: number = 100;
  @Input() rectX: number = 50;
  @Input() rectY: number = 50;
  @Input() textX: number = 100;
  @Input() textY: number = 100;
  @Input() maxWidth: number = 800;  // Max width of the canvas
  @Input() maxHeight: number = 600; // Max height of the canvas
  private ctx: CanvasRenderingContext2D;

  ngAfterViewInit(): void {
    const canvasEl = this.canvas.nativeElement;
    this.ctx = canvasEl.getContext('2d');
    const image = new Image();

    image.onload = () => {
      const aspectRatio = image.width / image.height;
      let canvasWidth = image.width;
      let canvasHeight = image.height;

      if (canvasWidth > this.maxWidth) {
        canvasWidth = this.maxWidth;
        canvasHeight = canvasWidth / aspectRatio;
      }

      if (canvasHeight > this.maxHeight) {
        canvasHeight = this.maxHeight;
        canvasWidth = canvasHeight * aspectRatio;
      }
      
      canvasEl.width = canvasWidth;
      canvasEl.height = canvasHeight;

      // Improve image quality
      this.ctx.imageSmoothingEnabled = true;
      this.ctx.imageSmoothingQuality = 'high';
      this.ctx.drawImage(image, 0, 0, canvasWidth, canvasHeight);

      // Draw a rectangle
      this.ctx.strokeStyle = this.rectColor;
      this.ctx.lineWidth = 5;
      this.ctx.strokeRect(this.rectX, this.rectY, this.rectWidth, this.rectHeight);

      // Draw some text
      this.ctx.font = '30px Arial';
      this.ctx.fillStyle = this.textColor;
      this.ctx.fillText(this.text, this.textX, this.textY);
    };

    image.src = this.imagePath;
  }
}
